export const defaultImage = 'https://static.tickchak.co.il/all/defaultImage.png';
export const defaultWhatsAppImage = 'https://static.tickchak.co.il/all/dln_00TTqZGZLlFUVpGbKBVeENXTtRXNSxmYzB3VZJUd3RGNMV3b5Z2dzRnaKZ2S_090TQK9yUjJzMKJVaupWSJFlTzJUMpN3V.png_e2eccecb-c17b-43ab-ad2b-844621a8534c.png?v=1645126231442';
